import * as React from 'react'
import { FunctionComponent, MouseEvent } from 'react'
import { IToggleProps, Toggle } from '@fluentui/react'
import { FormikContextType } from 'formik'
import { useTranslation } from 'react-i18next'

type Props = {
    context: FormikContextType<any>
    label: string
    fieldName: string
    toggleProps?: Omit<IToggleProps, 'label'>
}

const FormikTextField: FunctionComponent<Props> = props => {
    const { values, setFieldValue, handleBlur } = props.context
    const { t: translate } = useTranslation()

    return (
        <Toggle
            label={props.label}
            onText={translate('base.toggle.on')}
            offText={translate('base.toggle.off')}
            checked={values[props.fieldName]}
            onChange={(_: MouseEvent, value: boolean) => setFieldValue(props.fieldName, value)}
            onBlur={handleBlur(props.fieldName)}
            {...(props.toggleProps || {})}
        />
    )
}

export default FormikTextField
